import { useState, useEffect } from "react";
import { HeaderContainer } from "../atoms/containers/ContentContainers";
import { IcoBrand } from "../atoms/icons/IcoBrand";
import { Nav } from "../molecules/nav/Nav";
import { MenuButton } from "../molecules/menu_button/MenuButton";

const MOBILE_BREAKPOINT = "(max-width: 970px)";

export function Header() {
	const [isMobile, setIsMobile] = useState(() =>
		typeof window !== "undefined" ? window.matchMedia(MOBILE_BREAKPOINT).matches : false
	);
	const [open, setOpen] = useState(false);
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const mql = window.matchMedia(MOBILE_BREAKPOINT);
		const handler = (e) => setIsMobile(e.matches);
		mql.addEventListener("change", handler);
		return () => mql.removeEventListener("change", handler);
	}, []);

	useEffect(() => {
		const onScroll = () => setScrolled(window.scrollY > 12);
		onScroll();
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	useEffect(() => {
		if (open && isMobile) {
			document.body.classList.add("scroll-lock");
		} else {
			document.body.classList.remove("scroll-lock");
		}
		return () => document.body.classList.remove("scroll-lock");
	}, [open, isMobile]);

	useEffect(() => {
		if (!isMobile) setOpen(false);
	}, [isMobile]);

	return (
		<HeaderContainer scrolled={scrolled}>
			<a className="Nav_link" href="#hero" aria-label="Near Shore Design home">
				<IcoBrand className="-w7" />
			</a>
			<Nav open={open} setOpen={setOpen} isMobile={isMobile} />
			{isMobile && <MenuButton setOpen={setOpen} open={open} />}
		</HeaderContainer>
	);
}
